"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
var _companySelect = _interopRequireDefault(require("../company-select/company-select.js"));
require("./app-header.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  Header
} = _antd.Layout;
class AppHeader extends _react.Component {
  render() {
    const {
      auth,
      companyId,
      onCompanyChange,
      companySelectDisabled
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(Header, {
      className: "app-header"
    }, /*#__PURE__*/_react.default.createElement(_companySelect.default, {
      auth: auth,
      companyId: companyId,
      onChange: company => {
        if (typeof onCompanyChange === 'function') {
          onCompanyChange(company);
        }
      },
      companySelectDisabled: companySelectDisabled
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-bar"
    }, /*#__PURE__*/_react.default.createElement(_antd.Popover, {
      trigger: "click",
      placement: "bottomRight",
      title: this.renderUserMenuTitle(),
      content: this.renderUserMenuContent()
    }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
      className: "app-header-avatar",
      src: auth?.state?.claims?.picture
    }, this.getInitials()))));
  }
  renderUserMenuTitle = () => {
    const {
      auth
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "app-header-profile"
    }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
      src: auth?.state?.claims?.picture,
      size: 64
    }, this.getInitials()), /*#__PURE__*/_react.default.createElement("span", {
      className: "name"
    }, auth?.state?.claims?.name), /*#__PURE__*/_react.default.createElement("span", {
      className: "username"
    }, auth?.state?.claims?.username));
  };
  renderUserMenuContent = () => {
    const {
      auth
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "app-header-user-menu"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      type: "primary",
      ghost: true,
      onClick: auth.signOut
    }, /*#__PURE__*/_react.default.createElement("span", null, "Sign out"))));
  };
  getInitials = () => {
    const {
      auth
    } = this.props;
    const firstName = (auth?.state?.claims?.given_name || '')[0] || '';
    const lastName = (auth?.state?.claims?.family_name || '')[0] || '';
    return `${firstName}${lastName}`;
  };
}
var _default = exports.default = AppHeader;
//# sourceMappingURL=app-header.js.map